const SEEN_PREFIX = 'product_guide_seen_'

function storageKey(userId, guideId) {
  return `${SEEN_PREFIX}${String(userId)}_${guideId}`
}

function isGuideSeenKey(key) {
  return typeof key === 'string' && key.startsWith(SEEN_PREFIX)
}

/**
 * Очистка localStorage при выходе / сбросе сессии без потери отметок просмотренных гайдов.
 */
export function clearLocalStoragePreservingGuideSeen() {
  try {
    const preserved = {}
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i)
      if (key && isGuideSeenKey(key)) {
        preserved[key] = window.localStorage.getItem(key)
      }
    }
    window.localStorage.clear()
    for (const [key, value] of Object.entries(preserved)) {
      if (value != null) window.localStorage.setItem(key, value)
    }
  } catch (_) {
    window.localStorage.removeItem('access')
    window.localStorage.removeItem('refresh')
  }
}

/**
 * @param {string | number | null | undefined} userId
 * @param {string} guideId
 */
export function hasSeenGuide(userId, guideId) {
  if (userId == null || userId === '' || !guideId) return true
  try {
    return window.localStorage.getItem(storageKey(userId, guideId)) === '1'
  } catch (_) {
    return true
  }
}

/**
 * @param {string | number | null | undefined} userId
 * @param {string} guideId
 */
export function markGuideSeen(userId, guideId) {
  if (userId == null || userId === '' || !guideId) return
  try {
    window.localStorage.setItem(storageKey(userId, guideId), '1')
  } catch (_) {
    /* ignore quota / private mode */
  }
}
